import { render, staticRenderFns } from "./LanguageManagementView.vue?vue&type=template&id=6535d30d&scoped=true&"
import script from "./LanguageManagementView.vue?vue&type=script&lang=js&"
export * from "./LanguageManagementView.vue?vue&type=script&lang=js&"
import style0 from "./LanguageManagementView.vue?vue&type=style&index=0&id=6535d30d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6535d30d",
  null
  
)

export default component.exports